import { store } from "_store";
import { sidePanelActions } from '_store/sidePanel.slice';
import { getIcons } from "./getIcons";
import ReactDOMServer from 'react-dom/server';
import L from 'leaflet';

/**
 * Méthode pour ouvrir le SidePanel et y injecter les données
 * @param {*} data 
 */
export const openSidePanel = (data) => {
    store.dispatch(sidePanelActions.openPanel(data));
};

/**
 * Cible le bon icon en fonction de la cellule, la colonne et la page
 * Renvoie un icon coloré ou non
 * @param {*} h 
 * @param {*} row 
 * @param {*} pathname 
 * @returns 
 */
export const getSrc = (h,row, pathname) => {
    if( pathname.includes('/donnees/flotte/')){
        if(h.icon === 'STATE'){
            const iconLabel = mapIcons(row.STATE);
            return getIcons(iconLabel) 
        } else if(h.icon === 'MAX') {
            const iconLabel = mapIcons(row.MAX_LEVEL);
            return getIcons(iconLabel)
        }
    }
    if((pathname.includes('/donnees') || pathname.includes('/alertes')) && h.icon=== 'HEADER_CODE'){
        return getIcons(row[h.icon])
    }
    if (pathname === '/alertes/gestion') {
        if(h.key === 'shared') {            
            // si les emails sont remplis on utilise l'icone bleu, sinon le gris
            if(row?.emails.length > 0 && row?.emails[0] !== ''){
                return getIcons(h.icon);
            } else {
                return getIcons(h.icon2);
            }
        } else if(h.key === 'warning'){
            return row.error ? getIcons(h.icon) : null;
        }
        
    }

    if (row.URGENCY_LEVEL === '3' || row.URGENCY_LEVEL === '4'){
        const isAlertManagement = pathname === '/alertes/gestion';
        if (isAlertManagement){
            return h.icon === 'shareOutlined' ? getIcons(h.icon + 'White') : null
        }
        return getIcons(h.icon + 'White')
    }
    return h.icon === 'shareOutlined' ? null : getIcons(h.icon + 'Blue');
}

/**
 * Permet d'adapter les classes des cellules en fonction du contenu et du type
 * @param {*} index 
 * @param {*} h 
 * @returns 
 */
export const getCellClassName = (index, h, row, pathname) => {
    //console.log('cellclassname : ', index, h, row, pathname);
    
    const baseClass = h.icon ? '' : 'table-cell-body';
    const additionalClass = index === 0 ? 'border-cell-table' : '';
    const iconClass = h.icon ? 'icon-cell' : '';
    const widthClass = h.width ? `w-[${h.width}px]` : 'max-w-[200px]';

    let alertClass = '';

    if (
        pathname.includes('/donnees/bus') &&
        Array.isArray(row.offRangeIndex) &&
        row.offRangeIndex.includes(h.key)
    ) {
        alertClass = 'off-range-cell'; 
    }
    return `${baseClass} ${additionalClass} ${iconClass} ${widthClass} ${alertClass}`;
};

/**
 * Renvoie la valeur formattée / divisée avec séparateur de millier
 * @param {*} value 
 * @param {*} divider 
 * @returns 
 */
export const formatValue = (value, divider = null) => {
  let numberValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numberValue)) {
    return value; // Si la conversion échoue, retourne la valeur d'origine
  }
  if (divider && divider !== 0) {
    numberValue = numberValue / divider;
    numberValue = Math.round(numberValue);
  }

  return new Intl.NumberFormat('fr-FR').format(numberValue);
}

/**
 * Adapte le contenu d'une cellule pour le cas du niveau d'urgence
 * ajoute Niveau, Alerte ou stop en fonction de la valeur
 * @param {*} h 
 * @param {*} pathname 
 * @param {*} value 
 * @returns 
 */
export const getCellValue = (h, pathname, value, row) => {
    if(h.key.includes('CONTEXT')){
        const code = h.key.split('.')[1]
        if (code === 'VHM') return getVehicleMode(row.CONTEXT[code])
        if (code === 'SOC') return row.CONTEXT[code] ? `${row.CONTEXT[code]}%` : 'N/A'
        if (code === 'RANGE') return `${row.CONTEXT[code] ?? 0}km`
        return row.CONTEXT[code];
    }
    if(h.key.includes('DST')){
        return value ? `${formatValue(value, 1000)} km` : 'N/A'
    }
    if(pathname.includes('/donnees/flotte') && h.key === 'SOC') {
        //return `${value}%`
        return null;
    }
    if(pathname.includes('/donnees')) {
        if( h.key === 'URGENCY_LEVEL') {
            return `${urgencyLabel(value)} ${value}`;
        } else if (h.key === 'DST') {
            return value/1000;
        } 
    }
    return value
}

export const getRowClassName = (row, pathname = '') => {
    const baseClass = 'table-row';
    let additionalClass = '';
    if (row?.URGENCY_LEVEL === '3') {
        additionalClass = 'alert-3';
    } else if (row?.URGENCY_LEVEL === '4') {
        additionalClass = 'stop-4';
    }
    return `${baseClass} ${additionalClass}`;
};

/**
 * Renvoie la bonne classe d'icone en fonction du type et de l'icone
 * @param {*} h 
 * @returns 
 */
export const getIconClassName = (h) => {
    const baseClass = '';
    const additionalClass = h?.type === 'action' ? 'cursor-pointer' : '';
    const extraClass = h.icon === 'HEADER_CODE' ? 'm-auto' : 'ml-[30%]';
    return `${baseClass} ${additionalClass} ${extraClass}`;
}

export const getTitle = (h, row) => {
    return h.title ?? row[h.icon] ?? ''
}

/**
 * Converti les oéprateurs mathématiques en chaine de caractère
 * @param {*} sign 
 * @returns 
 */
export const convertOperator = (sign) => {
    switch (sign) {
        case ('Supérieur ou égal'):
            return ('>=');
        case ('Supérieur'):
            return ('>');
        case ('Égal'):
            return ('=');
        case ('Inférieur'):
            return ('<');
        case ('Inférieure ou égale'):
            return ('<=');
        case ('Compris'):
        case ('Contient'):
            return (sign);
        default:
            return (sign)    
    }
}

/**
 * Converti les chaines de caractères en opérateurs mathématiques
 * @param {*} sign 
 * @returns 
 */
export const revertOperator = (sign) => {
    switch (sign) {
        case ('>='):
            return ('Supérieur ou égal');
        case ('>'):
            return ('Supérieur');
        case ('='):
            return ('Égal');
        case ('<'):
            return ('Inférieur');
        case ('<='):
            return ('Inférieure ou égale');
        case ('Compris'):        
        case ('compris'):
            return ('Compris');
        case ('Contient'):
        case ('contient'):
            return ('Contient');
        default:
            return (sign)    
    }
}

/**
 * Gestion de la couleur en fonction du niveau d'alerte
 */
export const urgencyColors = {
    '0': 'pre-alert',  
    '1': 'pre-alert',  
    '2': 'pre-alert',
    '3': 'alert-3',
    '4': 'stop-4',  
    'EN EXPLOITATION': 'driving',
    'EN ATTENTE': 'driving',
    'EN CHARGE': 'pre-alert',
    'DEPOT': 'pre-alert',
    'OFFLINE': 'offline',
    'INCONNU': 'offline',
    '': 'offline'
};

/**
 * Gestion du label en fonction du niveau d'urgence
 */
export const urgencyLabel = (val) => {
    switch(val){
        case 0: 
        case 1: 
        case 2:
            return 'Niveau';
        case 3: 
            return 'Alerte';
        case 4: 
            return 'Stop';
        default:
            return 'Niveau';
    }
}

/**
 * Remplace le _ uniquement s'il est en fin de chaîne
 * 
 * @param {*} bus 
 * @returns 
 */
const removeUnderscoreAtEnd = (bus) => {
    return bus.HEADER_CODE_VMC ? bus.HEADER_CODE_VMC.replace(/_$/, "") : null ; 
};
/**
 * Préparation des données des bus pour l'affichage dans les tooltips
 * @param {*} bus 
 * @returns 
 */
export const transformBusPropertiesToData = (bus) => {
    const code = removeUnderscoreAtEnd(bus)
    return [
        { title: 'Flotte', value: bus.CITY },
        { title: 'Parc', value: bus.PARK_NUMBER },
        { title: 'Km', value: (bus.HEADER_DST / 1000).toFixed(2) + ' km' },
        { title: 'SOC', value: `${bus.SOC ?? 0}%` },
        { title: 'Etat', value: (bus.STATE === 'EN ATTENTE' ? 'EN EXPLOITATION' : bus.STATE)},
        { type: 'separator' },
        { title: urgencyLabel(bus.URGENCY_LEVEL), value: bus.URGENCY_LEVEL ?? 0 },
        { title: '', value: bus.DATE, icon: 'accessTimeOutlined'},
        { title: '', value: (code ? `${code} - ${bus.EVENT_DESC_FR ?? ''}` : ''), icon: code ?? 'noTransferOutlined' },
    ];
};

/**
 * Fonction pour créer un marqueur avec un fond carré et une icône SVG centrée
 * @param {*} svgUrl 
 * @param {*} bgColor 
 * @param {*} size 
 * @returns 
 */
export const createCustomIcon = (svgUrl, bgColor = '#fff', size = 30) => {
    const iconHtml = ReactDOMServer.renderToString(
        <div style={{
            backgroundColor: bgColor,
            width: size,
            height: size,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px', 
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)'
        }}>
        <img src={getIcons(svgUrl)} style={{ width: '80%', height: '80%' }} alt="icon" />
        </div>
    );

    return L.divIcon({
        html: iconHtml,
        className: '', // Évite d'ajouter des classes par défaut
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2] // Centre le marqueur sur les coordonnées
    });
};

/**
 * Icones pour les différents types de POI
 */
export const mapIcons = (val) => {
    switch(val){
        case 'dealer': 
            return 'storefrontOutlined';
        case 'depot': 
            return 'warehouseOutlined';
        case 'charger': 
            return 'evStationOutlined';
        case 'pantographe': 
            return 'evStationOutlined';
        case 0:         
        case 1: 
        case 2: 
        case '0':         
        case '1': 
        case '2':
        case 'EN ATTENTE':
        case 'EN EXPLOITATION':
            return 'directionsBusFilledOutlined';
        case 3:
        case '3': 
            return 'busAlertOutlined3';
        case 4:
        case '4': 
            return 'busAlertOutlined4';
        case 'DEPOT':         
            return 'directionsBusFilledOutlinedBlue';
        case 'EN CHARGE': 
            return 'chargingStationOutlined';
        case 'OFFLINE': 
            return 'noTransferOutlined';
        case 'INCONNU':
        default :
            return 'directionsBusFilledOutlinedGrey';
    }

};

/**
 * Types de POIs
 */
export const types = {
    dealer: 'Concessionnaire',
    depot: 'Dépôt',
    charger: 'Chargeur',
    pantographe: 'Pantographe',
}

/**
 * Fonction pour limiter la longueur des lignes d'adresse
 * @param {*} text 
 * @param {*} maxLength 
 * @returns 
 */
export const wrapText = (text, maxLength) => {
  if (!text) return "";
  const words = text.split(" ");
  let lines = [];
  let currentLine = "";

  words.forEach((word) => {
    if ((currentLine + word).length <= maxLength) {
      currentLine += word + " ";
    } else {
      lines.push(currentLine.trim());
      currentLine = word + " ";
    }
  });

  if (currentLine) lines.push(currentLine.trim());

  return lines.join("\n");
};

/**
 * Fonction pour transformer les propriétés en données pour le composant CustomTooltip
 * @param {*} properties 
 * @returns 
 */
export const transformPoiPropertiesToData = (properties) => {
  const addressParts = [
    properties.ADRESSE,
    properties.CP,
    properties.VILLE,
  ];

  // On applique la limite de 30 caractères pour chaque partie
  const formattedAddressParts = addressParts.map(part => wrapText(part, 30));

  // On combine les parties en les séparant par des sauts de ligne
  const wrappedAddress = formattedAddressParts.join("\n");

  return [
    { title: '', value: types[properties.TYPE_STATIC], icon: mapIcons(properties.TYPE_STATIC)},
    { title: '', value: wrappedAddress, icon: 'placeOutlined' }
  ];
};

/**
 * Fonction pour filtrer les éléments sans coordonnées valides
 * @param {*} features 
 * @returns 
 */
export const filterValidFeatures = (features) => {
  return features.filter(feature => {
    const coordinates = feature.geometry.coordinates;
    return coordinates &&
           coordinates.length === 2 &&
           typeof coordinates[0] === 'number' &&
           typeof coordinates[1] === 'number' &&
           !isNaN(coordinates[0]) &&
           !isNaN(coordinates[1]);
  });
};

/**
 * Fonction pour grouper les éléments par TYPE_STATIC et créer des FeatureCollection
 * @param {*} features 
 * @returns 
 */
export const createFeatureCollectionsByType = (features) => {
  const validFeatures = filterValidFeatures(features);

  const collections = validFeatures.reduce((acc, feature) => {
    const type = feature.properties.TYPE_STATIC;
    if (!acc[type]) {
      acc[type] = {
        type: 'FeatureCollection',
        features: []
      };
    }
    acc[type].features.push(feature);
    return acc;
  }, {});

  return collections;
};

/**
 * Liste les codes famille et les icones correspondant 
 * afin de les regrouper pour l'affichage
 */
export const codeFamilles = {
    'Statut': ['EM10','EM100','EL10','EM200','EM300','EM400'],
    'Batterie': ['DJ10','DJ20','FQ00','FQ01','FF10','FJ41','MC00'],
    'Divers': ['DF20', 'FF00', 'DE00','DE01','FC21','FJ00','FJ01','FG20',
        'DD30','FC30','FIB1','FF00','MJ30','FP10','FP11','MJ30','FP10','FP11','FA00','FA01'],
    'Traction': ['FF00', 'DJ00','EJ00'],
    'Frein': ['EB90','EB00','MB00','EB80','FB80','FP01','FB90'],
    'Confort Thermique': ['EH20','EH00','DH10','MH21','MH22'],
    'ABS': ['EB10', 'FB10'],
    'EBS': ['EB30', 'FB21'],
    'ESP': ['EB30', 'EB40', 'FB30'],
    'Ralentisseur': ['FJ03'],
    'Direction Assistée': ['FG10', 'MZ00', 'FG00', 'FG01']
}

/**
 * Fonction pour regrouper les icones warnings par famille
 * @param {*} warnings 
 * @param {*} codeFamilles 
 * @returns 
 */
export const groupWarningsByFamily = (warnings, codeFamilles) => {
    const groupedWarnings = {};

    if (warnings.length === 0){
        return null;
    } 
    
    warnings.forEach(warning => {
        const code = warning.CODE_VMC.replace(/_$/, "");  // Retire le "_" à la fin du code
        let found = false;

        // Vérifie chaque famille et ajoute le warning à la bonne famille
        for (const [family, codes] of Object.entries(codeFamilles)) {
            if (codes.includes(code)) {
                if (!groupedWarnings[family]) {
                    groupedWarnings[family] = [];
                }
                groupedWarnings[family].push(warning);
                found = true;
                break;
            }
        }
        
        // Si le warning ne correspond à aucune famille, le placer dans "autres"
        if (!found) {
            if (!groupedWarnings['Divers']) {
                groupedWarnings['Divers'] = [];
            }
            groupedWarnings['Divers'].push(warning);
        }
    });

    return groupedWarnings;
};

export const getVehicleMode = (value) => {
    switch (value) {
        case(1):
        case('1'):
            return ('Standby'); 
        case(2): 
        case('2'): 
            return ('Driving'); 
        case(3):
        case('3'): 
            return ('Charging');
        default :
            return 'N/A';
    }
}

/**
 * Fonction pour convertir une chaîne en objet Date
 * @param {*} str 
 * @returns 
 */
export const parseDate = (str) => {
    const [datePart, timePart] = str.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes, seconds] = timePart.split(":");

    return new Date(year, month - 1, day, hours, minutes, seconds);
}

export const parseDateFlexible = (str) => {
  // Format français : "13/10/2025 14:07:59"
  if (str.includes("/")) {
    const [datePart, timePart] = str.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes, seconds] = timePart.split(":");
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  // Format ISO simplifié : "2025-10-13 14:17:19"
  if (str.includes("-")) {
    return new Date(str.replace(" ", "T")); // Ajoute le "T" pour compatibilité ISO
  }

  throw new Error("Format de date non reconnu");
}

/**
 * Ajoute un champ 'offRangeIndex' à chaque entrée de data
 * Ce champ est un tableau des clés des valeurs hors plage définie
 * @param {*} data 
 * @returns 
 */
export function addOffRangeIndex(data) {
    const families = [
        "BatteryStateOfCharge",
        "BatteryMaxCellTemp",
        "BatteryCellVolt"
    ];

    return data.map(entry => {
        const offRange = [];

        families.forEach(family => {
        const keysInFamily = Object.keys(entry).filter(k => k.startsWith(family));
        if (keysInFamily.length === 0) return;

            const values = keysInFamily.map(k => Number(entry[k]));

            values.forEach((v, i) => {
                if (isNaN(v)) return;

                const others = values.filter((_, idx) => idx !== i && !isNaN(values[idx]));
                if (others.length === 0) return;

                const avg = others.reduce((a, b) => a + b, 0) / others.length;
                const low = avg * 0.90;
                const high = avg * 1.10;

                if (v < low || v > high) {
                    // On retourne la clé exacte, PAS un index ambigu
                    offRange.push(keysInFamily[i]);
                }
            });
        });

        return {
            ...entry,
            offRangeIndex: offRange
        };
    });
}

